export const courses = [
  {
    id: 1,
    slug: "maths",
    safe: "maths",
    name: "Mathematics",
    intro:
      "Our structured 11+ mathematics course is designed to build strong foundations and lasting exam success. We teach a variety of topics to ensure that your child will be well prepared for any 11+ maths exam they are planning to sit.",
    description:
      "Our maths curriculum has been intentionally designed with a clear and logical sequence. Each lesson strengthens core understanding before introducing new concepts, ensuring your child develops lasting confidence and a strong mathematical foundation. We also include regular revision and consolidation lessons to reinforce learning and make sure key ideas truly stick.",
    modules: [
      "Number",
      "Operations",
      "Geometry",
      "Fractions, Percentages and Ratios",
      "Data Handling and Probability",
      "Measurements and Applied Maths",
      "Advanced Number Theory",
      "Algebra and Equations",
    ],
    bpcolor: "#E5C2F0",
    tris: "https://d1sq738v7irhr2.cloudfront.net/courses/purple-tris.webp",
    vidd: "https://d1sq738v7irhr2.cloudfront.net/animations/maths.mp4",
    timer: 15,
    pdf: "temp-maths-c.pdf",
  },

  {
    id: 2,
    slug: "english",
    safe: "english",
    name: "English",
    intro:
      "Our 11+ English course is designed to give your child a strong grasp of the key skills needed for success in grammar school entrance exams. ",
    description:
      "Through a carefully structured programme, we cover reading comprehension, vocabulary, spelling, punctuation, grammar, and creative writing. Each lesson builds on the last, helping students develop confidence and precision in their written and verbal work. Regular revision and consolidation lessons ensure that key techniques are reinforced, so your child feels fully prepared and ready to perform at their best.",
    modules: [
      "Word types",
      "Punctuation",
      "Comprehension",
      "Writing",
      "Sentence Structure and Tenses",
      "SPAG",
      "Grammar",
      "Vocab & Word Knowledge",
    ],
    bpcolor: "#FDD765",
    tris: "https://d1sq738v7irhr2.cloudfront.net/courses/yellow-tris.webp",
    vidd: "https://d1sq738v7irhr2.cloudfront.net/animations/english.mp4",
    timer: 0,
    pdf: "temp-eng-c.pdf",
  },
  {
    id: 3,
    slug: "non-verbal-reasoning",
    safe: "nvr",
    name: "Non-Verbal Reasoning",
    intro:
      "Our 11+ Non-Verbal Reasoning course is designed to develop your child’s ability to think logically, spot patterns, and solve problems with confidence. ",
    description:
      "Through a clear and structured programme, students learn to interpret shapes, sequences, and visual information step by step. Regular revision and consolidation lessons help strengthen these skills, ensuring your child feels prepared and self-assured when approaching their 11+ exam.",
    modules: [
      "Relationships and Comparisons",
      "Patterns, Series and Sequences",
      "Spatial Reasoning and Visualisation",
      "Logical deduction and Matrices",
    ],
    bpcolor: "#FFC06D",
    tris: "https://d1sq738v7irhr2.cloudfront.net/courses/orange-tris.webp",
    vidd: "https://d1sq738v7irhr2.cloudfront.net/animations/nvr1.mp4",
    timer: 10,
    pdf: "temp-nvr-c.pdf",
  },
  {
    id: 4,
    slug: "verbal-reasoning",
    safe: "vr",
    name: "Verbal Reasoning",
    intro:
      "Our 11+ Verbal Reasoning course is designed to help your child develop the critical thinking and language skills needed for success in grammar school entrance exams. ",
    modules: [
      "Word Knowledge",
      "Word Relationships & Analogies",
      "Spelling & Word Manipulation",
      "Logical Deductions & Code Breaking",
      "Word Patterns & Patterns",
      "Logical Reasoning & Problem Solving",
      "Verbal Arithmatics",
    ],
    description:
      "Through a clear and structured programme, students develop essential verbal reasoning skills step by step. They learn to recognise word relationships, patterns in language, and logical connections between ideas. Regular revision and consolidation lessons reinforce understanding, ensuring your child feels confident, prepared, and self-assured when approaching their 11+ exam.",
    bpcolor: "#E2F0D9",
    tris: "https://d1sq738v7irhr2.cloudfront.net/courses/green-tris.webp",
    vidd: "https://d1sq738v7irhr2.cloudfront.net/animations/vr1.mp4",
    timer: 10,
    pdf: "temp-vr-c.pdf",
  },
];
